import { Task, TaskStatus, TaskType } from "../types/taskTypes";

/** Statuts renvoyés par le back (index ES `legal_task_jobs`). */
export function mapServerLegalJobStatus(
  status: string,
  errorCode?: string
): TaskStatus {
  const s = (status || "").toLowerCase();
  const ec = (errorCode || "").toLowerCase();
  if (ec === "cancelled" || ec === "canceled" || ec === "cancel_requested") {
    return TaskStatus.CANCELLED;
  }
  if (s === "completed") return TaskStatus.COMPLETED;
  if (s === "cancel_requested" || s === "cancelled" || s === "canceled") {
    return TaskStatus.CANCELLED;
  }
  if (s === "error") return TaskStatus.ERROR;
  if (s.includes("synthesizing")) return TaskStatus.SUMMARIZING;
  return TaskStatus.PROCESSING;
}

/** Une ligne `jobs[]` de `GET /legal/legal_jobs/{user_id}` (camelCase). */
export function taskFromLegalJobRow(
  row: Record<string, unknown>,
  page: string,
  mode: string
): Task {
  const taskId = String(row.taskId ?? row.task_id ?? "");
  const threadId = String(row.threadId ?? row.thread_id ?? "");
  const q = String(row.queryPreview ?? row.query_preview ?? "");
  const processed = Number(row.processedDocs ?? row.processed_docs ?? 0);
  const total = Math.max(1, Number(row.totalDocs ?? row.total_docs ?? 1));
  const st = String(row.status ?? "running");
  const errCode = String(
    row.errorCode ?? row.error_code ?? ""
  );
  const created =
    Date.parse(String(row.createdAt ?? row.created_at ?? "")) || Date.now();
  const updated =
    Date.parse(String(row.updatedAt ?? row.updated_at ?? "")) || Date.now();
  const mapped = mapServerLegalJobStatus(st, errCode);
  const fileStatus =
    mapped === TaskStatus.COMPLETED
      ? "summary_done"
      : mapped === TaskStatus.CANCELLED
      ? "cancelled"
      : "processing";

  const pageLabel = String(row.page ?? page ?? "legal").toLowerCase();
  const legalWipJobFormula = String(
    row.wipJobFormula ?? row.wip_job_formula ?? ""
  ).trim();

  return {
    id: taskId,
    type: TaskType.LEGAL_SEARCH,
    timestamp: updated,
    createdAt: created,
    updatedAt: updated,
    threadId: threadId || undefined,
    file: {
      filename: q || "—",
      nbPages: total,
      nbProcessed: Math.min(processed, total),
      nbProcessedSummary: 0,
      status: fileStatus,
    },
    status: mapped,
    page: pageLabel,
    mode: pageLabel,
    // Jobs issus de /legal/legal_jobs : reprise SSE côté serveur possible/attendue.
    requiresServerResume: true,
    ...(legalWipJobFormula ? { legalWipJobFormula } : {}),
  };
}
